import { useEffect, useRef } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const LOCAL_VERSION_KEY = 'app_version';
const CHECK_INTERVAL = 60000; // Check every 60 seconds

export const useVersionCheck = () => {
  const hasChecked = useRef(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await axios.get(`${API}/api/version`);
        const serverVersion = response.data.version;
        const localVersion = localStorage.getItem(LOCAL_VERSION_KEY);

        if (localVersion && localVersion !== serverVersion) {
          console.log(`Version mismatch detected: local=${localVersion}, server=${serverVersion}`);
          
          // Clear all caches
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(name => caches.delete(name)));
            console.log('Browser caches cleared');
          }

          // Update stored version
          localStorage.setItem(LOCAL_VERSION_KEY, serverVersion);
          
          // Force hard reload to get new assets
          window.location.reload(true);
        } else if (!localVersion) {
          // First time - just store the version
          localStorage.setItem(LOCAL_VERSION_KEY, serverVersion);
          console.log(`Version initialized: ${serverVersion}`);
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    };

    // Check on mount (but only once)
    if (!hasChecked.current) {
      hasChecked.current = true;
      checkVersion();
    }

    // Also check periodically for long-running sessions
    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
};

// Force version refresh - can be called manually
export const forceVersionRefresh = async () => {
  try {
    // Clear caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }
    
    // Clear localStorage version to force re-check
    localStorage.removeItem(LOCAL_VERSION_KEY);
    
    // Clear session storage
    sessionStorage.clear();
    
    // Force reload
    window.location.reload(true);
  } catch (error) {
    console.error('Force refresh failed:', error);
    window.location.reload(true);
  }
};
